import { BaseDto } from "@/shared/dtos/base-dto";

export class rol extends BaseDto {
  public nombre!: string;
}
